module.exports = __webpack_public_path__ + "img/icon-map-implantation-01.d26db5cd.svg";